import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
    fetchEditableProfile,
    fetchCompanyAds,
} from '../../actions/profileActions';
import { fetch as fetchOccupations } from '../../actions/occupationsActions';
import { update as updateImage } from '../EditProfile/actions/imageActions';
import analytics, * as trackingTypes from '../../actions/analyticsActions';
import EditImageModal from '../../components/editableMediaThumbnail/EditImageModal';
import { UPDATE_IMAGE_SUCCESS } from '../../constants/actionTypes';
import { createUrl } from '../../utils/createUrl';

function needsFetch({ loaded, loading }) {
    return !(loaded || loading);
}

class EditImage extends Component {
    static propTypes = {
        dispatch: PropTypes.func.isRequired,
        history: PropTypes.object.isRequired,
        location: PropTypes.shape({
            search: PropTypes.string,
        }).isRequired,
        profile: PropTypes.object.isRequired,
        occupations: PropTypes.object.isRequired,
        match: PropTypes.shape({
            params: PropTypes.shape({
                id: PropTypes.string.isRequired,
                imageId: PropTypes.string.isRequired,
            }).isRequired,
        }).isRequired,
    };

    componentDidMount() {
        const {
            dispatch,
            profile,
            occupations,
            match: { params },
        } = this.props;
        const id = parseInt(params.id, 10);
        const imageId = parseInt(params.imageId, 10);
        dispatch(analytics(trackingTypes.VIEW_EDIT_IMAGE, { id, imageId }));
        // Note: This doesn't check if the loaded profile or in-progress fetch is for
        // the same ID, it just assumes that they'll be the same since this component
        // only appears with the EditProfile component.
        if (needsFetch(profile)) {
            dispatch(fetchCompanyAds(id));
            dispatch(fetchEditableProfile(id));
        }
        if (needsFetch(occupations)) {
            dispatch(fetchOccupations());
        }
    }

    handleCloseClick() {
        const {
            history,
            location: { search },
            match: {
                params: { id },
            },
        } = this.props;
        history.push(createUrl(`/company/${id}/edit${search}`));
    }

    handleSave(updates) {
        const {
            match: { params },
            dispatch,
        } = this.props;
        const id = parseInt(params.id, 10);
        const imageId = parseInt(params.imageId, 10);
        dispatch(
            updateImage(id, {
                id: imageId,
                ...updates,
            })
        ).then((action) => {
            if (action.type === UPDATE_IMAGE_SUCCESS) {
                this.handleCloseClick();
            }
        });
    }

    render() {
        const { imageId } = this.props.match.params;
        const { occupations } = this.props.occupations;
        const {
            profile: { images },
            companyActiveAds,
        } = this.props.profile;
        if (images && occupations) {
            const image = images.images.find(
                ({ id }) => id === parseInt(imageId, 10)
            );
            return (
                <EditImageModal
                    error={Boolean(images.errorMessage)}
                    image={image}
                    occupationSuggestions={occupations}
                    occupations={image.occupations}
                    occupationsFromActiveAds={
                        companyActiveAds.occupations.specializations
                    }
                    onClose={this.handleCloseClick.bind(this)}
                    onSave={this.handleSave.bind(this)}
                    saving={images.loading}
                />
            );
        } else {
            return null;
        }
    }
}

export default connect(({ profile, occupations }) => ({
    profile,
    occupations,
}))(EditImage);
